module.exports = __webpack_public_path__ + "img/olga.b97d3538.png";